// 文章页推荐阅读广告加载逻辑，包括数据处理和渲染
const template = require('@/components/adver/xpsAd/feeds_ad.html')
import helper from "@/components/adver/helper"

/*
 广告形式	form字段	所采用的resource
 文字信息流	pcinfo_txt	title
 小图信息流	pcinfo_pictxt	title,picture
 组图信息流	pcinfo_mixpictxt	title,leftpicture,rightpicture,middlepicture,lastpicture
 通栏信息流	pcinfo_bannertxt	title,picture
 视频信息流	pcinfo_video	title,picture,video
 大图组图信息流 pcinfo_bigmixpictxt    title,leftpicture,rightpicture,lastpicture
 */
export class AdRenderer {
    constructor(opts) {
        this.data = opts.data;
        this.ad_id = opts.ad_id;
        this.el = opts.el;
        this.template = _.template(template);
    }

    // 广告数据处理逻辑，using_resource为最终用来渲染的数据源
    buildUsingResource(data) {
        data.using_resource = {};
        if (data.resource && data.resource.type == "iframe") {
            data.using_resource = data.resource;
        } else if (!data.special || !data.special.dict) {
            return;
        } else {
            data.adstyle = data.adstyle||"";
            //兼容标题获取逻辑
            var title_res = data[data.special.dict.title] || data[data.special.dict.txt] || {};
            var picture_res = data[data.special.dict.picture] || {};
            var video_res = data[data.special.dict.video] || {};
            var leftpicture = data[data.special.dict.leftpicture] || {};
            var middlepicture = data[data.special.dict.middlepicture] || {};
            var rightpicture = data[data.special.dict.rightpicture] || {};
            var lastpicture = data[data.special.dict.lastpicture] || {};
            if (data.form == "pcinfo_txt") {
                data.using_resource.title = title_res;
            }
            if (data.form == "pcinfo_pictxt") {
                data.using_resource.title = title_res;
                data.using_resource.picture = picture_res;
            }
            if (data.form == "pcinfo_mixpictxt") {
                data.using_resource.title = title_res;
                data.using_resource.leftpicture = leftpicture;
                data.using_resource.middlepicture = middlepicture;
                data.using_resource.rightpicture = rightpicture;
                data.using_resource.lastpicture = lastpicture;
            }
            //banner和大图广告采用同一个模板
            if (data.form == "pcinfo_bannertxt" || "pcinfo_bigpictxt") {
                data.using_resource.title = title_res;
                data.using_resource.picture = picture_res;
            }
            if (data.form == "pcinfo_video") {
                data.using_resource.title = title_res;
                data.using_resource.picture = picture_res;
                data.using_resource.video = video_res;
            }
            if (data.form == "pcinfo_bigmixpictxt") {
                data.using_resource.title = title_res;
                data.using_resource.leftpicture = leftpicture;
                data.using_resource.rightpicture = rightpicture;
                data.using_resource.lastpicture = lastpicture;
            }
        }
        // 给广告展示当前时间
        var date = new Date();
        data.using_resource.now = "今天 " + date.getHours() + ":" + date.getMinutes();
    }

    fix_ad_plus (resource) {
        if (resource && resource.click) {
            resource.click = helper.fix_adplus(resource.click, {
                apid: "beans_" + this.ad_id,
                impid: this.data && this.data.impression_id
            });
        }
    }

    render (data) {
        var result = "";
        this.buildUsingResource(data);
        for(var n in data.using_resource){
            this.fix_ad_plus(data.using_resource[n])
        }
        if (data.form == "pcinfo_mixpictxt" || data.form == "pcinfo_bannertxt" || data.form == "pcinfo_bigpictxt") {
            this.el && this.el?.classList?.add("news-box-thr");
        } else if (data.form == "pcinfo_video") {
            this.el?.classList?.add("god-pop");
            this.el?.classList?.remove("clear");
        }else if (data.form == "pcinfo_txt") {
            this.el?.classList?.add("god-pop");
            this.el?.classList?.add("news-box-txt");
        }
        try {
            result = this.template(data);
        } catch (e) {
            if(this.el)this.el.style.display = "none";
        }
        return result
    }
}